export default "/images/dc27f7f0cdfe6486f20ad835031e72b3.png";